import React from 'react';

export type BackActionHandler = () => void;

interface BackNavigationContextValue {
  handler: BackActionHandler | null;
  setHandler: (handler: BackActionHandler | null) => void;
}

const BackNavigationContext = React.createContext<BackNavigationContextValue | undefined>(undefined);

export function BackNavigationProvider({ children }: { children: React.ReactNode }) {
  const [handler, setHandlerState] = React.useState<BackActionHandler | null>(null);

  const setHandler = React.useCallback((next: BackActionHandler | null) => {
    setHandlerState(() => next);
  }, []);

  const value = React.useMemo(() => ({ handler, setHandler }), [handler, setHandler]);

  return (
    <BackNavigationContext.Provider value={value}>
      {children}
    </BackNavigationContext.Provider>
  );
}

export function useBackNavigation(): BackNavigationContextValue {
  const ctx = React.useContext(BackNavigationContext);
  if (!ctx) {
    throw new Error('useBackNavigation must be used within BackNavigationProvider');
  }
  return ctx;
}
